import { ApiClient } from "./api.ts";

export interface Secret {
    name: string;
    version: number;
    environment: string;
    organization_id?: string;
    updated_at?: string;
    tags?: string[];
}

export interface Tag {
    id: string;
    organization_id: string;
    name: string;
    metadata: {
        color?: string;
        description?: string;
    };
}

export class SecretService {
    private static instance: SecretService;
    private api = ApiClient.getInstance();

    private constructor() {}

    public static getInstance(): SecretService {
        if (!SecretService.instance) {
            SecretService.instance = new SecretService();
        }
        return SecretService.instance;
    }

    async list(orgId: string, env: string): Promise<Secret[]> {
        return this.api.request<Secret[]>(`/organization/${orgId}/secrets?env=${env}`) as any;
    }

    async store(orgId: string, env: string, name: string, value: string, sealed: boolean, tags: string[] = []): Promise<void> {
        await this.api.request(`/organization/${orgId}/secrets`, {
            method: 'PUT',
            body: JSON.stringify({ environment: env, name, value, sealed, tags })
        });
    }

    async updateSecret(orgId: string, env: string, name: string, newName: string, tags: string[] = []): Promise<void> {
        await this.api.request(`/organization/${orgId}/secrets/${name}`, {
            method: 'PATCH',
            body: JSON.stringify({ environment: env, new_name: newName, tags })
        });
    }

    async delete(orgId: string, env: string, name: string): Promise<void> {
        await this.api.request(`/organization/${orgId}/secrets/${name}?env=${env}`, {
            method: 'DELETE'
        });
    }

    async getPublicKey(orgId: string): Promise<string> {
        const res = await this.api.request<{ public_key: string }>(`/organization/${orgId}/secrets/public-key`) as any;
        return res.public_key;
    }

    async listTags(orgId: string): Promise<Tag[]> {
        return this.api.request<Tag[]>(`/organization/${orgId}/tags`) as any;
    }

    async createTag(orgId: string, name: string, color?: string, description?: string): Promise<Tag> {
        return this.api.request<Tag>(`/organization/${orgId}/tags`, {
            method: 'PUT',
            body: JSON.stringify({ name, color, description })
        }) as any;
    }

    async updateTag(orgId: string, tagId: string, name: string, color?: string, description?: string): Promise<Tag> {
        return this.api.request<Tag>(`/organization/${orgId}/tags/${tagId}`, {
            method: 'PATCH',
            body: JSON.stringify({ name, color, description })
        }) as any;
    }

    async deleteTag(orgId: string, tagId: string): Promise<void> {
        await this.api.request(`/organization/${orgId}/tags/${tagId}`, {
            method: 'DELETE'
        });
    }
}
